import type { Template } from "@/types";

export const PO_06_H1_V5: Template[] = [
    {
        id: "po-06-h1v5-01",
        name: "PO 01 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 77, y: 150, width: 533, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 512, width: 173, height: 253, rotation: 0, imageRotation: 0 },
            { id: "3", x: 258, y: 512, width: 172, height: 253, rotation: 0, imageRotation: 0 },
            { id: "4", x: 438, y: 512, width: 172, height: 253, rotation: 0, imageRotation: 0 },
            { id: "5", x: 752, y: 269, width: 275, height: 378, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 269, width: 275, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-02",
        name: "PO 02 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 152, y: 173, width: 383, height: 571, rotation: 0, imageRotation: 0 },
            { id: "2", x: 736, y: 173, width: 189, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 736, y: 463, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 933, y: 463, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 463, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "6", x: 933, y: 173, width: 386, height: 282, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "hs-06-h1v5-03",
        name: "HS 03 - H1V5",
        albumType: "HS",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 151, y: 173, width: 188, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 173, width: 187, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 151, y: 473, width: 383, height: 271, rotation: 0, imageRotation: 0 },
            { id: "4", x: 738, y: 173, width: 386, height: 571, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1132, y: 173, width: 189, height: 282, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1132, y: 463, width: 189, height: 281, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-04",
        name: "PO 04 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 73, y: 196, width: 536, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 532, width: 128, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 209, y: 532, width: 128, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 345, y: 532, width: 128, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 481, y: 532, width: 128, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 853, y: 196, width: 355, height: 524, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h1v5-05",
        name: "PO 05 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 237, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 462, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 210, y: 237, width: 653, height: 442, rotation: 0, imageRotation: 0 },
            { id: "4", x: 871, y: 237, width: 292, height: 442, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1171, y: 237, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1171, y: 462, width: 145, height: 217, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h1v5-06",
        name: "PO 06 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 237, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 462, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 210, y: 237, width: 653, height: 442, rotation: 0, imageRotation: 0 },       
            { id: "4", x: 871, y: 237, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 871, y: 462, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 237, width: 291, height: 442, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h1v5-07",
        name: "PO 07 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 237, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 462, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 237, width: 653, height: 442, rotation: 0, imageRotation: 0 },
            { id: "4", x: 210, y: 237, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 210, y: 462, width: 145, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 237, width: 291, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-08",
        name: "PO 08 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 272, width: 236, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 272, width: 236, height: 372, rotation: 0, imageRotation: 0 },
            { id: "3", x: 488, y: 272, width: 518, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1014, y: 272, width: 236, height: 372, rotation: 0, imageRotation: 0 },           
            { id: "5", x: 1258, y: 272, width: 116, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1258, y: 462, width: 116, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-09",
        name: "PO 09 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_09.png",
        size: [1374, 916],
        style: {},
        slots: [        
            { id: "1", x: 42, y: 148, width: 204, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 462, width: 204, height: 306, rotation: 0, imageRotation: 0 },
            { id: "3", x: 253, y: 148, width: 935, height: 620, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1196, y: 148, width: 136, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1196, y: 358, width: 136, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1196, y: 567, width: 136, height: 201, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h1v5-10",
        name: "PO 10 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 52, y: 175, width: 792, height: 565, rotation: 0, imageRotation: 0 },
            { id: "2", x: 852, y: 175, width: 231, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1091, y: 175, width: 231, height: 336, rotation: 0, imageRotation: 0 },
            { id: "4", x: 852, y: 519, width: 152, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1012, y: 519, width: 151, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1171, y: 519, width: 151, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },
];

